<template>
  <div class="row m-0 p-0">
    <div class="buttons-left">
      <div class="header-wrapper"
        style="text-align: start; font-size: 20px; margin-bottom: 10px; display: flex; justify-content: space-between;">
        {{ $t("Buttons") }}
        <div style="display:flex">
          <button class="btn btn-outline-secondary" @click="sectionType = 'add'; loadDefaultValues()"
            style="padding:0px !important; font-size:14px; height:28px; width:62px; border-radius:4px;">
            {{ $t('Create') }}
          </button>
        </div>
      </div>

      <div style="display: flex; flex-direction: column;">
        <div v-for="(group, groupId) in groups" :key="groupId" :style="group.length > 1 ? {
          border: '1px solid #4b4b4b',
          padding: '7px',
          gap: '8px',
          borderRadius: '8px',
          background: '#25282a'
        } : {}" class="button-group">
          <draggable :list="groups[groupId]"
            :options="{ animation: 150, group: 'buttons', ghostClass: 'btn-ghost', chosenClass: 'btn-chosen' }"
            item-key="_id" @add="onAddToGroup($event, groupId)" @update="onUpdate" :scroll-sensitivity="200"
            :force-fallback="true" drag-class="dragging-field" @start="onDragStart" @end="onDragEnd" @move="onMove"
            style="gap:9px; display:flex; flex-direction:column; position:relative">
            <template v-for="btn in sortedGroup(groups[groupId])">
              <div v-if="btn.status != 'deleted'" :key="btn._id" :data-id="btn._id">
                <div v-if="btn.position === 'Primary'" class="grouped-button-wrapper p-1"
                  :class="{ 'active-button-styles': buttonInfo && buttonInfo._id == btn._id }">
                  <button :style="buttonStyle(btn)" class="grouped-btn" @click="loadButtonDetails(btn)"
                    :title="btn.button_name">
                    <img v-if="btn.button_image" :src="getProxyConvertedURL(btn.button_image)" alt="btn image" class="btn-image" />
                    <i v-else-if="btn.button_icon" :class="['bi', 'bi-' + btn.button_icon]"></i>
                    <span v-if="btn.display_button_name">{{ btn.button_name }}</span>

                    <i v-if="groups[groupId].length > 1 && btn.position === 'Primary'"
                      @click.stop="toggleGroup(groupId)"
                      :class="expandedGroups[groupId] ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"
                      style="margin-inline-start:8px; cursor:pointer; position:absolute; inset-inline-end:12px"></i>
                  </button>

                  <div v-if="groups[groupId].length > 1" class="ungroup-button-icon" title="Remove from the group"
                    @click.stop="ungroupTheSelectedButton(btn)">
                    <i class="bi bi-x-lg"></i>
                  </div>

                  <div class="delete-button-icon" title="Delete">
                    <svg @click="deleteTheSelectedButton(btn)" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                      fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 
                               0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 
                               1 .5-.5m3 .5a.5.5 0 0 0-1 
                               0v6a.5.5 0 0 0 1 0z" />
                      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 
                               1-2 2H5a2 2 0 0 
                               1-2-2V4h-.5a1 1 0 0 
                               1-1-1V2a1 1 0 0 
                               1 1-1H6a1 1 0 0 
                               1 1-1h2a1 1 0 0 
                               1 1 1h3.5a1 1 0 0 
                               1 1 1zM4.118 4 4 4.059V13a1 1 0 0 
                               0 1 1h6a1 1 0 0 
                               0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                  </div>
                </div>

                <div v-if="expandedGroups[groupId] && btn.position === 'Secondary'" class="grouped-button-wrapper p-1"
                  :class="{ 'active-button-styles': buttonInfo && buttonInfo._id == btn._id }">
                  <button :style="buttonStyle(btn)" class="grouped-btn secondary" @click="loadButtonDetails(btn)"
                    :title="btn.button_name">
                    <img v-if="btn.button_image" :src="getProxyConvertedURL(btn.button_image)" alt="btn image" class="btn-image" />
                    <i v-else-if="btn.button_icon" :class="['bi', 'bi-' + btn.button_icon]"></i>
                    <span v-if="btn.display_button_name">{{ btn.button_name }}</span>
                  </button>

                  <div class="ungroup-button-icon" title="Remove from the group"
                    @click.stop="ungroupTheSelectedButton(btn)">
                    <i class="bi bi-x-lg"></i>
                  </div>

                  <div class="delete-button-icon" title="Delete">
                    <svg @click="deleteTheSelectedButton(btn)" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                      fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 
                               6v6a.5.5 0 0 1-1 
                               0V6a.5.5 0 0 1 .5-.5m2.5 
                               0a.5.5 0 0 1 .5.5v6a.5.5 
                               0 0 1-1 0V6a.5.5 0 0 
                               1 .5-.5m3 .5a.5.5 0 0 
                               0-1 0v6a.5.5 0 0 0 1 0z" />
                      <path d="M14.5 3a1 1 0 0 
                               1-1 1H13v9a2 2 0 0 
                               1-2 2H5a2 2 0 0 
                               1-2-2V4h-.5a1 1 0 0 
                               1-1-1V2a1 1 0 0 
                               1 1-1H6a1 1 0 0 
                               1 1-1h2a1 1 0 0 
                               1 1 1h3.5a1 1 0 0 
                               1 1 1zM4.118 4 4 4.059V13a1 
                               1 0 0 0 1 1h6a1 1 0 0 
                               0 1-1V4.059L11.882 4zM2.5 
                               3h11V2h-11z" />
                    </svg>
                  </div>
                </div>
              </div>
            </template>
          </draggable>
        </div>

        <draggable :list="ungrouped"
          :options="{ animation: 150, group: 'buttons', removeOnSpill: false, ghostClass: 'btn-ghost', chosenClass: 'btn-chosen', fallbackOnBody: true }"
          item-key="_id" :key="'ungrouped'" drag-class="dragging-field" :scroll-sensitivity="200" :force-fallback="true"
          @start="onDragStart" @end="onDragEnd" @remove="onRemove" @change="onChange" @move="onMove"
          @add="onAddToUngrouped" class="ungrouped-container"
          style="display:flex; flex-wrap:wrap; gap:10px; margin-top:10px;">
          <template v-for="btn in ungrouped">
            <div v-if="btn.status != 'deleted'" :key="btn._id" class="draggable-item w-100"
              :class="{ 'hover-group': hoverTargetId === btn._id }" :data-id="btn._id" style="position: relative;"
              @dragover.prevent="onDragOver(btn._id)" @dragleave="onDragLeave"
              @drop.prevent="onDropCreateGroup(btn._id)">
              <button :style="buttonStyle(btn)" class="grouped-btn" :title="btn.button_name">
                <img v-if="btn.button_image" :src="getProxyConvertedURL(btn.button_image)" alt="btn image" class="btn-image" />
                <i v-else-if="btn.button_icon" :class="['bi', 'bi-' + btn.button_icon]"></i>
                <span v-if="btn.display_button_name">{{ btn.button_name || btn.title }}</span>
              </button>

              <div v-if="hoverTargetId === btn._id && draggingBtnId && draggingBtnId !== btn._id"
                class="group-formation-preview">
                <button class="grouped-btn preview-secondary" :style="buttonStyle(getDraggedBtn())"
                  :title="getDraggedBtn().button_name">
                  <img v-if="getDraggedBtn().button_image" :src="getProxyConvertedURL(getDraggedBtn().button_image)" alt="btn image"
                    class="btn-image" />
                  <i v-else-if="getDraggedBtn() && getDraggedBtn().button_icon"
                    :class="['bi', 'bi-' + getDraggedBtn().button_icon]"></i>
                  <span v-if="getDraggedBtn().display_button_name">
                    {{ getDraggedBtn() ? (getDraggedBtn().button_name || getDraggedBtn().title) : '' }}
                  </span>
                </button>
              </div>

              <div class="delete-button-icon" title="Delete">
                <svg @click="deleteTheSelectedButton(btn)" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                  fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 
                           6v6a.5.5 0 0 1-1 
                           0V6a.5.5 0 0 1 .5-.5m2.5 
                           0a.5.5 0 0 1 .5.5v6a.5.5 
                           0 0 1-1 0V6a.5.5 0 0 
                           1 .5-.5m3 .5a.5.5 0 0 
                           0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 
                           1-1 1H13v9a2 2 0 0 
                           1-2 2H5a2 2 0 0 
                           1-2-2V4h-.5a1 1 0 0 
                           1-1-1V2a1 1 0 0 
                           1 1-1H6a1 1 0 0 
                           1 1-1h2a1 1 0 0 
                           1 1 1h3.5a1 1 0 0 
                           1 1 1zM4.118 4 4 4.059V13a1 
                           1 0 0 0 1 1h6a1 1 0 0 
                           0 1-1V4.059L11.882 4zM2.5 
                           3h11V2h-11z" />
                </svg>
              </div>
            </div>

            <div class="drop-zone" :class="{ active: hoverIndex === ungrouped.length }"
              @dragover.prevent="hoverIndex = ungrouped.length" @dragleave="hoverIndex = null"
              @drop.prevent="handleDropAt(ungrouped.length)" :key="btn._id + '-after'"></div>
          </template>
        </draggable>
      </div>
    </div>
    <div class="buttons-info-right">
      <div style="display:flex; align-items:flex-start; justify-content:space-between; width:100%;">
        <div class="common-input-field" style="margin-top:7px;width:60%">
          <label>{{ $t('Button Name') }} *</label>
          <div v-if="!isEditable('button_name')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
            <span class="task-data-value"> {{ $t(buttonInfo.button_name) }}</span>
            <edit-icon @click.native="editIconClick('button_name')" class="editIcon"></edit-icon>
          </div>
          <div v-if="isEditable('button_name')" class="input-field-value-div" style="display:flex">
            <input type="text" ref="buttonNameField"
              class="bg-transparent border rounded text-light form-control input-fields" placeholder="Enter Button Name"
              v-model="buttonInfo.button_name">
            <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
              <save-icon @click.native="saveTheEditedField('button_name')"></save-icon>
              <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
            </div>
          </div>
          <div class="config-desc">
            {{ $t('The label or text that will appear on the button') }}.
          </div>
        </div>
        <div class="learn-about-text-styles" style="margin-top:14px;" @click="showLearnAboutPanel = true">
          <i class="bi bi-lightbulb-fill"></i>
          {{ $t('Learn about buttons configuration') }}
        </div>
      </div>
      <div class="common-input-field" style="width:60%;margin-top: 7px;">
        <div style="display:flex">
          <div style="width:210px">
            <label style="width:100%">{{ $t('Display Button Name') }}</label>
          </div>
          <div class="custom-control custom-switch">
            <input
              @change="buttonInfo.display_button_name = !buttonInfo.display_button_name, sectionType == 'edit' ? saveTheEditedField('display_button_name') : ''"
              type="checkbox" class="custom-control-input" id="customSwitch1"
              :checked='buttonInfo.display_button_name' />
            <label class="custom-control-label" for="customSwitch1"></label>
          </div>
        </div>
        <div class="config-desc">
          {{ $t('Toggle to show or hide the button name') }}.
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;width:60%">
        <label>{{ $t('Button Type') }} </label>
        <div v-if="!isEditable('button_type')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
          <span class="task-data-value"> {{ $t(buttonInfo.button_type) }}</span>
          <edit-icon @click.native="editIconClick('button_type')" class="editIcon"></edit-icon>
        </div>
        <div v-if="isEditable('button_type')" class="input-field-value-div" style="display:flex">
          <Multiselect v-model="buttonInfo.button_type" :options="buttontypeOptions" placeholder="Select type"
            :close-on-select="true" :allow-empty="false" deselectLabel="" selectLabel="" selectedLabel="">
            <div slot="singleLabel" slot-scope="{ option }">
              {{ option }}
            </div>
            <span slot="noResult">{{ $t('No results') }}.</span>
          </Multiselect>
          <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
            <save-icon @click.native="saveTheEditedField('button_type')"></save-icon>
            <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
          </div>
        </div>
        <div class="config-desc">
          {{ $t('Defines the functional role of the button') }}
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;width:60%">
        <label>{{ $t('Context') }} </label>
        <div v-if="!isEditable('context')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
          <span v-if="!buttonInfo.context || buttonInfo.context.length == 0" class="empty-field-text-styles">
            {{ $t('None') }}</span>
          <span class="task-data-value"> {{ $t(buttonInfo.context) }}</span>
          <edit-icon @click.native="editIconClick('context')" class="editIcon"></edit-icon>
        </div>
        <div v-if="isEditable('context')" class="input-field-value-div" style="display:flex">
          <Multiselect v-model="buttonInfo.context" :options="buttoncontextOptions" placeholder="Select Context"
            :close-on-select="true" :allow-empty="false" deselectLabel="" selectLabel="" selectedLabel="">
            <div slot="singleLabel" slot-scope="{ option }">
              {{ option }}
            </div>
            <span slot="noResult">{{ $t('No results') }}.</span>
          </Multiselect>
          <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
            <save-icon @click.native="saveTheEditedField('context')"></save-icon>
            <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
          </div>
        </div>
        <div class="config-desc">
          {{ $t('Specifies the context in which the button will be displayed') }}
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;">
        <label>{{ $t('Action Rule') }} *</label>
        <div v-if="!isEditable('action_rule')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
          <span class="task-data-value"> {{ $t(buttonInfo.action_rule) }}</span>
          <edit-icon @click.native="editIconClick('action_rule')" class="editIcon"></edit-icon>
        </div>
        <div v-if="isEditable('action_rule')" class="input-field-value-div" style="display:flex">
          <textarea class="bg-transparent border rounded text-light form-control" style="padding-inline-end: 4%;"
            tabindex="2" autocomplete="off" :placeholder="$t('Enter Rule using FSL')"
            v-model="buttonInfo.action_rule"></textarea>
          <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
            <save-icon @click.native="saveTheEditedField('action_rule')"></save-icon>
            <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
          </div>
        </div>
        <div class="config-desc">
          {{ $t(learnAboutTexts.actionRuleDesc) }}.
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;">
        <label>{{ $t('Permission') }} </label>
        <div v-if="!isEditable('permissions')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
          <span v-if="buttonInfo.permissions.length == 0" class="empty-field-text-styles"> {{ $t('None') }}</span>
          <span class="task-data-value"> {{ $t(buttonInfo.permissions) }}</span>
          <edit-icon @click.native="editIconClick('permissions')" class="editIcon"></edit-icon>
        </div>
        <div v-if="isEditable('permissions')" class="input-field-value-div" style="display:flex">
          <textarea class="bg-transparent border rounded text-light form-control" style="padding-inline-end: 4%;"
            tabindex="3" autocomplete="off" :placeholder="$t('Enter Permission using FSL')"
            v-model="buttonInfo.permissions"></textarea>
          <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
            <save-icon @click.native="saveTheEditedField('permissions')"></save-icon>
            <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
          </div>
        </div>
        <div class="config-desc">
          {{ $t(learnAboutTexts.permissionDesc) }}.
        </div>
      </div>
      <div class="common-input-field" style="margin-top: 7px;">
        <div>
          <label style="width:100%">{{ $t('Button Icon') }}</label>
        </div>
        <div style="display:flex">
          <div style="display: flex;justify-content: center;margin:20px 0px">
            <div class="profile-image-upload-wrapper">
              <div class="profile-image-display">
                <img v-if="imageType == 'image'" :src="getProxyConvertedURL(buttonInfo.button_image)" style="height:100%;width:100%">
                <svg v-else-if="imageType == null" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16"
                  style="height: 100px !important;width: 100% !important;color: #4e4e4e;">
                  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                  <path
                    d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                </svg>
                <canvas v-else-if="imageType == 'canvas'" ref="buttonImageUploadCanvas" id="canvas"></canvas>
              </div>
              <div class="upload-profile-image-button" :style="imageType != null ? 'display: flex;width: 185px;' : ''">
                <div class="btn-wrapper cover-image">
                  <button v-if="imageType == null"
                    class="btn btn-outline-primary cover-image-change">{{ $t('Upload') }}</button>
                  <button v-else class="btn btn-outline-primary cover-image-change">{{ $t('Change') }}</button>
                  <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                    <input type="file" id="img-input" ref="uploadFile" @change="uploadProfileImage($event)"
                      accept="image/*">
                  </div>
                </div>

                <div v-if="imageType != null" style="position:relative;" class="btn-wrapper mb-0">
                  <button class="btn btn-outline-secondary" @click="removeCoverImage()">{{ $t('Remove') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div
            style="text-align:start;border-inline-start: 1px solid #3a3a3a;margin-inline-start: 17px;padding-inline-start: 8px;">
            <icons-selector :fromAddMode="true" @icon-selected="updateSelectedIcon"
              :icon="buttonInfo.button_icon ? buttonInfo.button_icon : ''"></icons-selector>
            <button
              @click="buttonInfo.button_icon = ''; sectionType === 'edit' ? saveTheEditedField('button_icon') : null"
              class="btn btn-outline-secondary"
              style="padding: 4px 10px;font-size: 12px;margin: 9px;">{{ $t('Unset') }}</button>
          </div>
        </div>
        <div class="config-desc">
          {{ $t('Selected Icon will be displayed on the button') }} .
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;">
        <label>{{ $t('Button Colour') }} </label>
        <div class="input-field-value-div" style="display:flex">
          <div style="display:flex;justify-content: start;flex-flow: wrap;">
            <div @click="selectColor('')"
              style="min-height:30px;min-width:30px; margin-inline-end:5px;border-radius:15px;margin-bottom:5px;display: flex;justify-content: center;align-items: center; cursor: pointer;"
              class="add-border-on-hover none-button-color">
              <svg v-if="!buttonInfo.button_color || buttonInfo.button_color.length == 0"
                xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" class="bi bi-check2"
                viewBox="0 0 16 16" style="background: #120d0d52;border-radius: 10px;">
                <path
                  d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1-.708 0z" />
              </svg>
            </div>
            <div v-for="color in colorPickers.slice(0, visibleCount)" :key="color" :style="'background:' + color"
              @click="selectColor(color)"
              style="min-height:30px;min-width:30px; margin-inline-end:5px;border-radius:15px;margin-bottom:5px;display: flex;justify-content: center;align-items: center; cursor: pointer;"
              class="add-border-on-hover">
              <svg v-if="buttonInfo.button_color && buttonInfo.button_color == color" xmlns="http://www.w3.org/2000/svg"
                width="20" height="20" fill="#fff" class="bi bi-check2" viewBox="0 0 16 16"
                style="background: #120d0d52;border-radius: 10px;">
                <path
                  d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1-.708 0z" />
              </svg>
            </div>
            <span v-if="visibleCount < colorPickers.length" @click="visibleCount += 100"
              style="cursor: pointer; margin-top: 5px;display: flex;align-items: end;" class="load-more">
              ... {{ $t('load more') }}
            </span>
          </div>
        </div>
        <div class="config-desc">
          {{ $t(learnAboutTexts.buttonColourFieldDesc) }}.
        </div>
      </div>
      <div class="common-input-field" style="width:60%;margin-top: 7px;">
        <div style="display:flex">
          <div style="width:200px">
            <label style="width:100%">{{ $t('Fill background color') }}</label>
          </div>
          <div class="custom-control custom-switch">
            <input
              @change="buttonInfo.fill_background_color = !buttonInfo.fill_background_color, sectionType == 'edit' ? saveTheEditedField('fill_background_color') : ''"
              type="checkbox" class="custom-control-input" id="customSwitch2"
              :checked='buttonInfo.fill_background_color' />
            <label class="custom-control-label" for="customSwitch2"></label>
          </div>
        </div>
        <div class="config-desc">
          {{ $t(learnAboutTexts.fillBackgroundDesc) }}.
        </div>
      </div>
      <div class="common-input-field" style="margin-top:7px;width:60%">
        <label>{{ $t('Button Position') }} </label>
        <div v-if="!isEditable('position')" class="desc-text-cursor" style="max-height:200px;overflow:auto;">
          <span class="task-data-value"> {{ $t(buttonInfo.position) }}</span>
        </div>
        <div v-if="isEditable('position')" class="input-field-value-div" style="display:flex">
          <Multiselect v-model="buttonInfo.position" :options="buttonPositionOptions" placeholder="Select Position"
            :close-on-select="true" :allow-empty="false" deselectLabel="" selectLabel="" selectedLabel=""
            :disabled="sectionType === 'add'">
            <div slot="singleLabel" slot-scope="{ option }">
              {{ option }}
            </div>
            <span slot="noResult">{{ $t('No results.') }}</span>
          </Multiselect>
          <div v-if="sectionType == 'edit'" class="d-flex" style="height: 40px;align-items: center;">
            <save-icon @click.native="saveTheEditedField('position')"></save-icon>
            <cancel-icon @click.native="editingKeyName = null"></cancel-icon>
          </div>
        </div>
        <div class="config-desc">
          {{ $t('Position where button needs to be displayed') }}
        </div>
      </div>
      <div v-if="sectionType != 'edit'" class="primary-btn-style">
        <button @click="addNewButtonClick()" class="btn btn-outline-primary" data-v-198e7d7f=""
          style="position: relative; float: inline-end; inset-inline-start:">
          {{ $t('Save') }}
        </button>
        <button @click="cancelAddition()" class="btn btn-outline-secondary mr-3"
          data-dismiss="modal">{{ $t('Cancel') }}</button>
      </div>
    </div>

    <div v-if="showLearnAboutPanel" class="learn-about-overlay" @click.self="showLearnAboutPanel = false">
      <div class="learn-about-panel">
        <div class="learn-about-panel-header">
          <h5>{{ $t('Buttons') }}</h5>
          <i class="bi bi-x-lg" style="cursor:pointer;" @click="showLearnAboutPanel = false"></i>
        </div>
        <div class="learn-about-panel-body">

          <div class="learn-about-field-row">
            <strong>{{ $t('Button Name') }} :</strong>
            <span>{{ $t('The label or text that will appear on the button') }}.</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Button Type') }} :</strong>
            <span>{{ $t('Defines the functional role of the button') }}.</span>
          </div>
          <div class="learn-about-subheading">{{ $t('There are two types of button') }}.</div>
          <div class="learn-about-numbered-item">
            <span class="learn-about-badge">1</span>
            <span>{{ $t('Default') }}</span>
          </div>
          <div class="learn-about-numbered-item">
            <span class="learn-about-badge">2</span>
            <span>{{ $t('AI') }}</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Context') }} :</strong>
            <span>{{ $t('Specifies where the button will be displayed') }}.</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Action Rule') }} :</strong>
            <span>{{ $t('The rule that defines what happens when this button is clicked') }}.</span>
          </div>
          <div class="learn-about-example-box">
            <div class="learn-about-example-title">
              <i class="bi bi-pencil-fill"></i> {{ $t('Example') }}:
            </div>
            <pre class="learn-about-code-block">{{ learnAboutActionRuleExample }}</pre>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Permission') }} :</strong>
            <span>{{ $t('Controls who can see or use this button') }}.</span>
          </div>
          <div class="learn-about-example-box">
            <div class="learn-about-example-title">
              <i class="bi bi-pencil-fill"></i> {{ $t('Example') }}:
            </div>
            <pre class="learn-about-code-block">{{ learnAboutPermissionExample }}</pre>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Button Icon / Image') }} :</strong>
            <span>{{ $t('An icon or image to display on the button') }}.</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Button Colour') }} :</strong>
            <span>{{ $t('The color used for the button outline or background') }}.</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Button Position') }} :</strong>
            <span>{{ $t('Determines how the button is placed when grouped with another button') }}.</span>
          </div>
          <div class="learn-about-subheading">{{ $t('There are two positions') }}.</div>
          <div class="learn-about-numbered-item">
            <span class="learn-about-badge">1</span>
            <span>{{ $t('Primary - always visible, shown first in a group') }}.</span>
          </div>
          <div class="learn-about-numbered-item">
            <span class="learn-about-badge">2</span>
            <span>{{ $t('Secondary - hidden until the group is expanded') }}.</span>
          </div>

          <div class="learn-about-field-row">
            <strong>{{ $t('Grouping') }} :</strong>
            <span>{{ $t('Drag one button onto another to group them together') }}.</span>
          </div>

          <div class="learn-about-section-divider"></div>
          <div class="learn-about-section-title">{{ $t('Asset Keys') }}</div>
          <div class="learn-about-field-row">
            <span>{{ $t('Copy a supported asset key below to use directly in your FSL rule') }}.</span>
          </div>
          <div class="learn-about-copyable-row">
            <code>ASSET.ARCHIVED == TRUE/FALSE</code>
            <span
              class="learn-about-copy-icon"
              :title="$t('Click to copy')"
              @click="copyLearnAboutSnippet('ASSET.ARCHIVED == TRUE/FALSE')"
            >
              <i class="bi bi-clipboard"></i>
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// NOTE: Make sure you have these components imported/defined in your project
import EditIcon from "../core/InlineEditField";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import icons from "./iconsInMediaPipeline.vue";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "ButtonsSettings",
  components: {
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "icons-selector": icons,
    Multiselect,
    draggable
  },
  data() {
    return {
      visibleCount: 15,
      editingKeyName: null,
      sectionType: "edit",
      showLearnAboutPanel: false,
      learnAboutTexts: {
        actionRuleDesc: "The rule (written in FSL) that defines what action will happen when this button is clicked",
        permissionDesc: "The access rule (using FSL) that controls who can see or use this button",
        buttonColourFieldDesc: "Pick a color for the button outline (or main color if background fill is enabled)",
        fillBackgroundDesc: "Toggle to fill the button with the selected color. If off, only the outline/icon uses the color"
      },
      learnAboutActionRuleExample: "TRIGGER:JOB:<job_name>\nTRIGGER:EVENT:<event_name>\nIF (<condition>) {\n    TRIGGER:JOB:<job_name>;\n}",
      learnAboutPermissionExample: "PERMISSION:userID:<user_id>\nPERMISSION:groupID:<group_id>",
      originalList: null,
      removedIndex: null,
      removedElement: null,
      hoverIndex: null,
      imageType: null,
      buttonInfo: {
        button_name: "",
        action_rule: "",
        permissions: "",
        button_color: "",
        button_icon: "",
        fill_background_color: false,
        position: "Primary",
        button_type: "Default",
        context: "",
        icon: null,
        button_image: null,
        display_button_name: true
      },
      expandedGroups: {},
      hoverTargetId: null,
      draggingBtnId: null,
      buttonsList: [], // real source list
      groups: {},      // { groupId: [btn, ...] }
      ungrouped: [],   // buttons without group_id
      buttontypeOptions: ["Default", "AI"],
      buttonPositionOptions: ["Primary", "Secondary"],
      buttoncontextOptions: ["None", "Task", "Chat", "Review", "Asset", "Project"],
      PROFILE_IMAGE_ALLOWED_WIDTH: 128,
      colorPickers: [
        "#DB2828", "#F2711C", "#FBBD08", "#B5CC18",
        "#21BA45", "#00B5AD", "#2185D0", "#6435C9",
        "#A333C8", "#E03997", "#FFFFFF", "#000000",
        "#808080", "#C0C0C0"
      ]
    };
  },
  computed: {
    allExpanded() {
      return Object.values(this.expandedGroups).every(v => v);
    },
    getDraggedBtn() {
      return this.buttonsList.find(b => b._id === this.draggingBtnId) || {};
    },
  },
  watch: {
    buttonsList: {
      handler() {
        this.rebuildGroups(true);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("buttons", [
      "getAllBUttonsFromServer",
      "addNewButton",
      "updateExistingButton",
      "deleteExistingButton"
    ]),
    ...mapMutations("websocket", [
      "addWSEventListener",
      "removeWSEventListener"
    ]),

    sortedGroup(group) {
      return group.slice().sort((a, b) => {
        if (a.position === "Primary" && b.position === "Secondary") return -1;
        if (a.position === "Secondary" && b.position === "Primary") return 1;
        return 0;
      });
    },

    buttonStyle(btn) {
      const baseColor = btn.button_color && btn.button_color.trim() !== "" ? btn.button_color : null;
      if (!baseColor) return {};
      if (btn.fill_background_color) {
        return {
          border: `1px solid ${baseColor}`,
          background: baseColor,
          color: this.getContrastColor(baseColor)
        };
      }
      return {
        border: `1px solid ${baseColor}`,
        background: "transparent",
        color: baseColor
      };
    },

    getContrastColor(hex) {
      let c = hex.replace("#", "");
      if (c.length === 3) {
        c = c.split("").map(ch => ch + ch).join("");
      }
      const r = parseInt(c.substr(0, 2), 16);
      const g = parseInt(c.substr(2, 2), 16);
      const b = parseInt(c.substr(4, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? "#000" : "#fff";
    },

    loadDefaultValues() {
      this.$nextTick(() => {
        if (this.$refs.buttonNameField) {
          this.$refs.buttonNameField.focus();
        }
      });
      this.buttonInfo = {
        button_name: "",
        action_rule: "",
        permissions: "",
        button_color: "",
        fill_background_color: false,
        position: "Primary",
        button_type: "Default",
        context: "",
        icon: null,
        button_icon: "",
        button_image: null,
        display_button_name: true
      };
      this.imageType = null;
    },

    uploadProfileImage(ev) {
      this.imageType = "canvas";
      let file = ev.target.files[0];
      let blobURL = URL.createObjectURL(file);
      this.drawImage(blobURL, false);
    },

    drawImage(blobURL) {
      this.imageType = "canvas";
      const img = new Image();
      img.src = blobURL;
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        console.error("Could not load selected image.");
      };
      img.onload = () => {
        URL.revokeObjectURL(img.src);
        const canvas = this.$refs.buttonImageUploadCanvas;
        const ctx = canvas.getContext("2d");
        const size = this.PROFILE_IMAGE_ALLOWED_WIDTH;
        canvas.width = size;
        canvas.height = size;
        const scale = Math.min(size / img.naturalWidth, size / img.naturalHeight);
        const newWidth = img.naturalWidth * scale;
        const newHeight = img.naturalHeight * scale;
        const x = (size - newWidth) / 2;
        const y = (size - newHeight) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, x, y, newWidth, newHeight);
        this.$nextTick(() => {
          this.buttonInfo.button_image = canvas.toDataURL();
          if (this.sectionType === "edit") {
            this.saveTheEditedField("button_image");
          }
        });
      };
    },

    removeCoverImage() {
      this.buttonInfo.button_image = "";
      this.imageType = null;
      if (this.sectionType === "edit") {
        this.saveTheEditedField("button_image");
      }
    },

    selectColor(color) {
      this.$set(this.buttonInfo, "button_color", color);
      if (this.sectionType === "edit") {
        this.saveTheEditedField("button_color");
      }
    },

    /**
     * Handles group cleanup: if only one button remains in a group after one is removed,
     * it's promoted to Primary (either with old ID or new ID).
     */
    async cleanupGroup(oldGroupId, excludedBtnId) {
      if (!oldGroupId) return;

      // Find remaining active buttons in the group, excluding the one that was just deleted/moved
      const remainingButtons = this.buttonsList.filter(
        b => b.group_id === oldGroupId && b._id !== excludedBtnId && b.status !== 'deleted'
      );

      this.rebuildGroups();

      if (remainingButtons.length === 0) {
        return;
      }

      // Check if the group now has no Primary
      const currentPrimary = remainingButtons.find(b => b.position === 'Primary');

      if (!currentPrimary) {
        // Promote the first remaining button to Primary
        const newPrimary = remainingButtons.sort((a, b) => a.order - b.order)[0] || remainingButtons[0];

        // If only ONE remains, it gets a NEW group ID as per requirement (Ungroup/Delete Primary)
        if (remainingButtons.length === 1) {
          const newGroupId = "g" + Date.now();
          newPrimary.group_id = newGroupId;
          newPrimary.position = 'Primary';

          await this.updateExistingButton({
            _id: newPrimary._id,
            updatedData: { group_id: newGroupId, position: 'Primary' }
          });
          this.$toast.info(`Button '${newPrimary.button_name}' promoted to Primary with a new group`);
        }
        // If MULTIPLE remain, they keep the old group ID, and one is simply promoted.
        else {
          newPrimary.position = 'Primary';
          await this.updateExistingButton({
            _id: newPrimary._id,
            updatedData: { position: 'Primary' }
          });
          this.$toast.info(`Button '${newPrimary.button_name}' promoted to Primary within its group`);
        }
      }

      this.rebuildGroups(); // Final rebuild to reflect new positions/IDs
    },

    /**
     * Removes a button from its current group and makes it an independent Primary button 
     * with a new group ID. (Bound to the new Cross icon)
     */
    async ungroupTheSelectedButton(btn) {
      if (!btn || !btn.group_id) {
        this.$toast.warning("This button is already independent.");
        return;
      }

      const oldGroupId = btn.group_id;
      const newGroupId = "g" + Date.now();

      // 1. Update local state to make it a new single-member group
      btn.group_id = newGroupId;
      btn.position = "Primary";

      // 2. Persist changes to the API
      await this.updateExistingButton({
        _id: btn._id,
        updatedData: { group_id: newGroupId, position: "Primary" }
      });

      this.$toast.success(`Button '${btn.button_name}' removed from group.`);

      // 3. Clean up the group it left
      this.cleanupGroup(oldGroupId, btn._id);

      // 4. Rebuild the UI groups structure
      this.rebuildGroups();
    },

    deleteTheSelectedButton(buttonInfo) {
      if (confirm("Are you sure you want to delete the selected button permanently?")) {
        const oldGroupId = buttonInfo.group_id;

        // 1. Initiate deletion 
        this.deleteExistingButton({ _id: buttonInfo._id }).then(data => {
          if (data.statusCode == 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });

        // 2. Immediately call cleanup for the group the button belonged to
        if (oldGroupId) {
          this.cleanupGroup(oldGroupId, buttonInfo._id);
        }
      }
    },

    cancelAddition() {
      this.buttonInfo = this.buttonsList[0] || this.buttonInfo;
    },

    addNewButtonClick() {
      if (this.buttonInfo.button_name.trim().length == 0) {
        alert("Button Name is required");
        return;
      }
      if (this.buttonInfo.action_rule.trim().length == 0) {
        alert("Action Rule is required");
        return;
      }
      if (this.buttonInfo.context.trim().length == 0) {
        delete this.buttonInfo.context;
      }
      this.addNewButton(this.buttonInfo).then(data => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
          this.sectionType = "edit";
          this.buttonInfo = data.upserted_data;
        } else {
          this.$toast.error(data.message);
          return;
        }
      });
    },

    editIconClick(keyName) {
      this.editingKeyName = keyName;
    },

    saveTheEditedField(keyName) {
      if (keyName == "context" && this.buttonInfo.context == "None") {
        this.buttonInfo.context = "";
      }
      this.updateExistingButton({
        _id: this.buttonInfo._id,
        updatedData: { [keyName]: this.buttonInfo[keyName] }
      }).then(data => {
        if (data.statusCode === 200) {
          this.$toast.success(data.message);
          this.editingKeyName = null;
        } else {
          this.$toast.error(data.message);
        }
      });
    },

    updateSelectedIcon(icon) {
      if (this.buttonInfo.button_icon == icon) {
        this.buttonInfo.button_icon = "";
      } else {
        this.buttonInfo.button_icon = icon;
      }
      if (this.sectionType == "edit") {
        this.saveTheEditedField("button_icon");
      }
    },

    // --- DRAGGING / GROUPING HANDLERS ---

    onMove(evt) {
      try {
        const draggedEl = evt.dragged;
        const relatedEl = evt.related;
        if (!draggedEl || !relatedEl) {
          this.hoverTargetId = null;
          return true;
        }
        const draggedId = draggedEl.getAttribute("data-id") || (draggedEl.dataset && draggedEl.dataset.id);
        const relatedId = relatedEl.getAttribute("data-id") || (relatedEl.dataset && relatedEl.dataset.id);
        if (!draggedId || !relatedId) {
          this.hoverTargetId = null;
          return true;
        }
        const draggedBtn = this.buttonsList.find(b => b._id === draggedId);
        const relatedBtn = this.buttonsList.find(b => b._id === relatedId);

        // Only set hoverTargetId if BOTH are ungrouped (for grouping preview)
        if (draggedBtn && relatedBtn && !draggedBtn.group_id && !relatedBtn.group_id && draggedId !== relatedId) {
          this.hoverTargetId = relatedId;
        } else {
          this.hoverTargetId = null;
        }
      } catch (e) {
        this.hoverTargetId = null;
      }
      return true;
    },

    onDragStart(evt) {
      this.draggingBtnId = evt.item.dataset.id || evt.item.getAttribute("data-id");
      this.originalList = evt.from.__vue__.list;
    },

    onRemove(evt) {
      this.removedElement = evt.item.__vue__?.element || null;
      this.removedIndex = evt.oldIndex;
    },

    onChange() {
      this.removedElement = null;
    },

    onDragEnd(evt) {
      if (!evt.to || evt.to === evt.from) {
        if (this.originalList && this.removedElement) {
          this.originalList.splice(this.removedIndex, 0, this.removedElement);
        }
      }
      this.draggingBtnId = null;
      this.removedElement = null;
      this.removedIndex = null;
      this.originalList = null;
      this.hoverTargetId = null;
    },

    rebuildGroups() {
      this.groups = {};
      this.ungrouped = [];
      this.buttonsList.forEach(btn => {
        if (btn.group_id) {
          if (!this.groups[btn.group_id]) this.$set(this.groups, btn.group_id, []);
          this.groups[btn.group_id].push(btn);
        } else {
          this.ungrouped.push(btn);
        }
      });
      Object.keys(this.groups).forEach(id => {
        if (this.expandedGroups[id] === undefined) {
          this.$set(this.expandedGroups, id, true);
        }
      });
    },

    onDragOver(targetId) {
      this.hoverTargetId = targetId;
    },

    onDragLeave() {
      this.hoverTargetId = null;
    },

    /**
     * Handles dropping an ungrouped button onto another ungrouped button (creating a new group).
     */
    async onDropCreateGroup(targetId) {
      const movedBtnId = this.draggingBtnId;
      const movedBtn = this.buttonsList.find(b => b._id === movedBtnId);
      const targetBtn = this.buttonsList.find(b => b._id === targetId);

      if (!movedBtn || !targetBtn || movedBtn.group_id) return;

      let targetGroupId = targetBtn.group_id;

      if (!targetGroupId) {
        // Ungrouped dropped onto Ungrouped -> Create NEW Group
        targetGroupId = "g" + Date.now();

        // 1. Update target button (the one dropped on) to be Primary
        targetBtn.group_id = targetGroupId;
        targetBtn.position = "Primary";
        await this.updateExistingButton({
          _id: targetBtn._id,
          updatedData: { group_id: targetGroupId, position: "Primary" }
        });
      }

      // 2. Update moved button (the one dropped) to be Secondary
      movedBtn.group_id = targetGroupId;
      movedBtn.position = "Secondary";
      await this.updateExistingButton({
        _id: movedBtn._id,
        updatedData: { group_id: targetGroupId, position: "Secondary" }
      });

      this.hoverTargetId = null;
      this.rebuildGroups();
    },

    handleDropAt(index) {
      // Logic for reordering/dropping onto the end of the ungrouped container
      const btn = this.buttonsList.find(b => b._id === this.draggingBtnId);
      if (!btn) return;

      const oldGroupId = btn.group_id;

      // Update local array for reordering
      this.ungrouped.splice(index, 0, this.ungrouped.splice(this.ungrouped.indexOf(btn), 1)[0]);

      // Update properties if it came from a group
      if (oldGroupId) {
        btn.group_id = null;
        btn.position = "Primary";
        this.updateExistingButton({
          _id: btn._id,
          updatedData: { group_id: null, position: "Primary" }
        });
        this.cleanupGroup(oldGroupId, btn._id);
      }

      this.rebuildGroups();
      this.hoverIndex = null;
    },

    /**
     * Handles dropping a button into an existing group.
     */
    async onAddToGroup(evt, targetGroupId) {
      const movedBtnId = evt.item.getAttribute("data-id") || evt.item.dataset.id;
      const btn = this.buttonsList.find(b => b._id === movedBtnId);
      if (!btn) return;

      const oldGroupId = btn.group_id; // Capture old group ID for cleanup

      // Determine position
      const hasPrimary = this.buttonsList.some(
        b => b.group_id === targetGroupId && b.position === "Primary" && b._id !== btn._id
      );
      const newPosition = hasPrimary ? "Secondary" : "Primary";

      // Update local state
      btn.group_id = targetGroupId;
      btn.position = newPosition;

      // Persist changes
      await this.updateExistingButton({
        _id: movedBtnId,
        updatedData: { group_id: targetGroupId, position: newPosition }
      }).then(data => {
        if (data.statusCode === 200) {
          this.$toast.success(data.message);
          this.editingKeyName = null;
        } else {
          this.$toast.error(data.message);
        }
      });

      // Handle cleanup for the group it left
      if (oldGroupId && oldGroupId !== targetGroupId) {
        this.cleanupGroup(oldGroupId, movedBtnId);
      }

      this.rebuildGroups();
    },

    /**
     * Handles dropping a button into the ungrouped container. (FIXED)
     */
    async onAddToUngrouped(evt) {
      const movedBtnId = evt.item.dataset.id;
      const btn = this.buttonsList.find(b => b._id === movedBtnId);
      if (!btn) return;

      const oldGroupId = btn.group_id; // Capture old group ID for cleanup

      // 1. UNGROUP the button
      btn.group_id = null;
      btn.position = "Primary";

      // 2. Persist changes to the API
      await this.updateExistingButton({
        _id: btn._id,
        updatedData: { group_id: null, position: "Primary" }
      });

      // 3. Handle cleanup for the group it left
      if (oldGroupId) {
        this.cleanupGroup(oldGroupId, movedBtnId);
      }

      this.rebuildGroups();
    },

    toggleGroup(id) {
      this.$set(this.expandedGroups, id, !this.expandedGroups[id]);
    },

    toggleAllGroups() {
      const expand = !this.allExpanded;
      Object.keys(this.expandedGroups).forEach(id => {
        this.$set(this.expandedGroups, id, expand);
      });
    },

    copyLearnAboutSnippet(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          if (this.$toast) {
            this.$toast.success(this.$t ? this.$t('Copied') : 'Copied');
          }
        }).catch(() => {
          this.fallbackCopyLearnAboutSnippet(text);
        });
      } else {
        this.fallbackCopyLearnAboutSnippet(text);
      }
    },

    fallbackCopyLearnAboutSnippet(text) {
      try {
        const tempInput = document.createElement("textarea");
        tempInput.value = text;
        tempInput.setAttribute("readonly", "");
        tempInput.style.position = "absolute";
        tempInput.style.left = "-9999px";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        if (this.$toast) {
          this.$toast.success(this.$t ? this.$t('Copied') : 'Copied');
        }
      } catch (err) {
        if (this.$toast) {
          this.$toast.error(this.$t ? this.$t('Unable to copy') : 'Unable to copy');
        }
      }
    },

    loadButtonDetails(btn) {
      this.buttonInfo = btn;
      this.sectionType = "edit";
      if (this.buttonInfo.button_image && this.buttonInfo.button_image.length != 0) {
        this.imageType = "image";
      } else {
        this.imageType = null;
      }
    },

    isEditable(key) {
      if (this.sectionType === "edit") return key === this.editingKeyName;
      return true;
    },

    onUpdate() {
      this.rebuildGroups();
    },

    handleButtonsConfigurationCRUDFromNotification(notification) {
      notification = notification.detail && Object.keys(notification.detail).length != 0
        ? notification.detail
        : notification;
      let messageInfo = notification.message;
      if (notification.message_type == "BUTTON_DELETED" && messageInfo) {
        const index = this.buttonsList.findIndex(b => b._id === messageInfo._id);
        if (index != -1) {
          this.buttonsList.splice(index, 1);
          if (this.buttonInfo && this.buttonInfo._id == messageInfo._id) {
            this.buttonInfo = this.buttonsList[0] || {
              button_name: "",
              action_rule: "",
              permissions: "",
              button_color: "",
              button_icon: "",
              fill_background_color: false,
              position: "Primary",
              button_type: "Default",
              context: "",
              icon: null,
              button_image: null,
              display_button_name: true
            };
            this.sectionType = this.buttonsList.length ? "edit" : "add";
          }
          if (this.buttonsList.length == 0) {
            this.sectionType = "add";
          } else {
            this.rebuildGroups();
          }
        }
      } else if ((notification.message_type == "BUTTON_CREATED" || notification.message_type == "BUTTON_UPDATED") && messageInfo) {
        const index = this.buttonsList.findIndex(b => b._id === messageInfo._id);
        if (index != -1) {
          this.$set(this.buttonsList, index, messageInfo);
        } else {
          this.buttonsList.push(messageInfo);
        }
        this.rebuildGroups();
      }
    },

    registerforWebsocketNotifications() {
      this.addWSEventListener({
        eventname: ["BUTTON_DELETED", "BUTTON_CREATED", "BUTTON_UPDATED"],
        callback: this.handleButtonsConfigurationCRUDFromNotification,
        parent: "buttonsConfiguration"
      });
    },

    unRegisterforWebsocketNotifications() {
      this.removeWSEventListener({
        eventname: ["BUTTON_DELETED", "BUTTON_CREATED", "BUTTON_UPDATED"],
        callback: this.handleButtonsConfigurationCRUDFromNotification,
        parent: "buttonsConfiguration"
      });
    }
  },

  beforeDestroy() {
    this.unRegisterforWebsocketNotifications();
  },

  mounted() {
    this.rebuildGroups(true);
  },

  created() {
    let payload = { params: { status: "active" } };
    this.getAllBUttonsFromServer(payload).then(res => {
      this.buttonsList = res.buttons;
      if (this.buttonInfo.button_image && this.buttonInfo.button_image.length != 0) {
        this.imageType = "image";
      }
      if (this.buttonsList.length > 0) {
        let firstBtn = this.buttonsList[0];
        if (this.groups && this.groups[this.buttonsList[0].group_id]) {
          this.buttonInfo =
            this.groups[firstBtn.group_id].find(btn => btn.position === "Primary") ||
            this.groups[firstBtn.group_id][0];
        } else {
          this.buttonInfo = this.buttonsList[0] || this.buttonInfo;
        }
      }
      this.sectionType = res.buttons.length ? "edit" : "add";
    });
    this.registerforWebsocketNotifications();
  }
};
</script>

<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
$border-color-only: #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color: #15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size: 14px;
$input-field-height: 38px;
$none-text-color: #4f4f4f;
$input-field-padding: .375rem 10px;
$scrollbar-thumb-background: #333;
$scrollbar-track-background: #1a1e21;
$scrollbar-thumb-on-hover-background: #555;
$tags-background-color: #282d31;
$tags-border-color: #363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$readOnly-bg-color: #1e2326 !important;
$add-button-text-color: #0b7099;
$add-button-text-color-hover: #0193cc;
$add-button-border-color: #b7b228;
$add-button-border-on-hover: #dcd426;
$add-button-backgroud: #1e1e1e;
$highlight-font-color: #ff9800;
$learn-about-text-color: #9a9620;
$learn-about-text-color-hover: #b7b327;

.none-button-color {
  border: $border-color !important;
}

/* ghost (dragged placeholder) */
.btn-ghost {
  opacity: 0.5 !important;
  transform: scale(0.98) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  transition: all 0.12s ease;
  height: auto;
}

/* selected / chosen element (original being dragged) */
.btn-chosen {
  opacity: 0.6 !important;
  filter: brightness(0.95);
}

/* ensure draggable item is relative for absolute preview placement */
.draggable-item {
  position: relative;
  margin: 4px 0;
  display: inline-block;
}

/* group formation preview that appears to the right of the target ungrouped button */
.group-formation-preview {
  position: absolute;
  inset-inline-start: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
  pointer-events: none;
  z-index: 60;
  padding: 4px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(1px);
}

/* make the preview secondary button look slightly smaller/lighter */
.group-formation-preview .preview-secondary {
  opacity: 0.95;
  font-size: 13px;
  padding: 6px 10px;
}

/* if the preview overflows use a higher z-index and subtle shadow */
.group-formation-preview .grouped-btn {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.24);
}

/* Highlight when dragging over an ungrouped button */
.draggable-item.hover-group button {
  background-color: #d1ecf1 !important;
  /* light blue */
  border: 2px dashed #17a2b8;
  /* teal border */
  color: #000;
}

/* Group container */
.button-group {
  transition: border-color 0.2s, background-color 0.2s;
}

/* Highlight whole group when dragging into it */
.button-group.hover-group-box {
  border: 2px solid #17a2b8 !important;
  /* teal border */
  background-color: #e8f7fa !important;
  /* light teal background */
}

/* Primary button always stands out */
.grouped-btn {
  min-height: 40px;
  font-weight: 500;
  padding: 6px 14px;
  transition: all 0.2s;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 6px;

  i {
    font-size: 20px
  }
}

/* Active button selected for editing */
.active-button-styles {
  outline: 2px solid #007bff;
  border-radius: 11px !important;
}

.hover-group {
  background-color: #d1ecf1;
  /* light teal highlight */
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.draggable-item {
  position: relative;
}

.load-more {
  color: $secondary-text-color;
}

.load-more:hover {
  text-decoration: underline;
}

.common-input-field {
  span {
    user-select: text !important;
    cursor: text;
  }
}

.active-button-styles {
  border-radius: 5px;
  border: 2px solid #007bff;
}

.button-group {
  display: flex;
  overflow: hidden;
  margin: 6px 0px;
  flex-direction: column;
  margin-bottom: 4px;
}

.grouped-btn {
  padding: 8px 16px;
  background: transparent;
  cursor: pointer;
  width: 100%;
  border: $border-color;
}

.config-desc {
  color: $dull-text-color;
  font-size: 12px;
}

.buttons-info-right {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 75%;
  position: relative;
}

.add-border-on-hover:hover {
  border: 2px solid #505050 !important;
}

.buttons-left {
  border-inline-end: 1px solid #373737;
  width: 25%;
  padding: 7px;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-top: 0px;
}

.header-wrapper {
  position: sticky;
  top: -1px;
  background: $primary-background;
  z-index: 99999;
  height: 40px;
  align-items: center;
}

ul {
  list-style-type: none;
}

.primary-btn-style {
  justify-content: flex-end;
  position: sticky;
  bottom: -1px;
  background: $primary-background;

  button {
    height: 35px;
    width: 70px;
    font-size: 14px;
  }
}

.secondary-btn-style {
  color: $text-color;
}

.close-icon:hover {
  border-radius: 20px;
}

.nav-item {
  color: $dull-text-color !important;
}

.inactive:hover {
  color: $text-color !important;
}

.active {
  background: $primary-background !important;
  color: $active-blue !important;
  border-bottom: 2px solid $active-blue ;
}

.top-nav-bar {
  text-align: center;
  background: $primary-background;
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: 1px solid #4a4a4a;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
}

.user-name {
  margin-inline-end: 6px;
  position: relative;
  bottom: 7px;
  font-size: 14px;
}

.ungrouped-container {
  margin: 6px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $bg-color-on-hover !important;
}

.common-input-field {
  margin: 5px 10px;
  display: inline-block;
  width: 96%;
  justify-content: space-between;
  display: inline-block;
  padding: 9px;
  border-radius: 4px;
  background: $primary-background;
  border: $secondary-border-color !important;

  label {
    width: 100%;
    color: $secondary-text-color;
    word-break: break-word;
    text-align: start;
  }

  .desc-text-cursor {
    min-height: 38px;
    border-radius: 5px;
    border: 1px solid $border-color-only;
  }

  input {
    flex: 1;
    min-height: 38px;
  }
}

.input-text-field {
  height: 44px;
  width: 100% !important;
  padding-inline-start: 2%;
  padding-inline-end: 2%;
  overflow: hidden;
}

.drop-zone {
  flex-basis: 100%;
  /* force to appear in row layout */
  height: 0;
  opacity: 0;
  transition: all 0.2s ease;
}

.drop-zone.active {
  height: 40px;
  opacity: 1;
  border: 2px dashed #bbb;
  border-radius: 6px;
  background: #fafafa;
}

.add-border {
  border: $border-color;
}

.minMaxTextarea {
  min-height: 38px;
}

textarea:focus {
  outline: none;
  bottom: 0px;
  inset-inline-start: 0px;
  --saf-0: rgba(var(--sk_highlight, 18, 100, 163), 1);
  box-shadow: 0 0 0 1px var(--saf-0), 0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.dull-the-text {
  color: $dull-text-color;
}

::placeholder {
  color: $dull-text-color !important;
}

.common-input-field:hover {
  .editIcon {
    visibility: visible;
    margin-inline-start: 8px;
  }
}

.editIcon {
  visibility: hidden;
}

.input-fields {
  font-size: 14px;
}

.empty-field-text-styles {
  color: $dull-text-color;
  font-size: 14px;
  margin-top: 1px;
}

textarea {
  min-height: 38px;
}

.button-styles {
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.primary-btn-style {
  display: flex;
  justify-content: flex-start;
  gap: 11px;
  padding: 10px;
}

.grouped-button-wrapper {
  position: relative;
}

::v-deep {

  .multiselect--disabled {
    background: unset;

    .multiselect__select {
      background: unset;
    }
  }

  .align-input-field-assets-search {
    .multiselect__tags {
      height: auto !important;
    }
  }

  .multiselect {
    margin: 3px 0px;
  }

  .multiselect__element:has(.disable-option) {
    /* Add your styles for the parent element here */
    pointer-events: none;
    cursor: none;
    background: #362121;
    opacity: 0.3;
  }

  .multiselect_tags {
    min-height: 40px !important;
    height: 40px !important;
    padding: 8px 40px 0 8px !important;
    border-radius: 5px !important;
  }

  .multiselect__content-wrapper {
    display: none;
  }

  .multiselect__tag,
  .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
    margin-top: 7px !important;
  }

  .multiselect__tags,
  .tags-style {
    background: transparent !important;
    border: $border-color !important;
    display: flex !important;
    align-items: flex-start !important;
    flex-direction: column;
  }

  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }

  .multiselect__content {
    background: $secondary-background-color !important;
  }

  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    word-break: break-all;
  }

  .multiselect__single {
    padding-inline-start: 9px !important;
    margin-top: 0px !important;
    padding-top: 6px !important;
    height: 38px !important;
  }

  .multiselect__input {
    padding-top: 0px !important;
    margin-bottom: 0px !important;
  }

  .multiselect__tag-icon {
    color: $text-color !important;
  }

  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }

  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }

  .multiselect__tags:focus,
  .multiselect__input:focus {
    outline: none;
    height: 38px;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight, 18, 100, 163), 1);
    box-shadow: 0 0 0 1px var(--saf-0), 0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size;
    font-family: "Roboto", Arial, sans-serif !important;
  }

  .multiselect__placeholder {
    padding-inline-start: 8px;
  }

  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px !important;
    top: 0px !important;
    height: auto !important;
  }

  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }

  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute !important;
    display: block;
    background: $text-color;
    width: 100% !important;
    max-height: 180px !important;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }

  .multiselect__tags {
    padding: 4px 0px 5px 0px;
    height: 38px !important;
  }

  .multiselect__tags-wrap {
    max-height: 150px !important;
    display: flex !important;
    overflow: auto;
  }

  .multiselect__tags-wrap::-webkit-scrollbar {
    width: 8px;
  }

  .multiselect__tags-wrap::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  .multiselect__tags-wrap::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  .multiselect__tags-wrap::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 8px;
  }

  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background: #22272b !important;
  }

  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

  font[color~=OrangeRed] {
    color: $highlight-font-color !important;
  }

  .bigger-checkboxes {
    height: 30px;
    width: 20px;
    position: relative;
  }

  input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
  }

  input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
  }
}

.search-in-filter-styles {
  padding: 2px 8px;
  margin-inline-end: 5px;
  margin-bottom: 5px;
  background-color: #1a1e21 !important;
  border: 1px solid #4a4a4a;
  border-radius: 5px;
  font-size: 14px;
  width: fit-content;
}

.desc-text-cursor {
  display: flex;
  padding: 10px;
}

.hover-group {
  background-color: #d1ecf1;
  /* light teal highlight */
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.delete-button-icon {
  position: absolute;
  top: 0px;
  inset-inline-end: 0px;
  border: $border-color;
  height: 25px;
  width: 25px;
  border-radius: 20px;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #161616;
  cursor: pointer;
}

.ungroup-button-icon {
  position: absolute;
  top: 0px;
  inset-inline-end: 26px;
  /* Adjusted position to make space for delete icon */
  border: $border-color;
  height: 25px;
  width: 25px;
  border-radius: 20px;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #161616;
  cursor: pointer;
}

.draggable-item:hover,
.grouped-button-wrapper:hover {

  .delete-button-icon,
  .ungroup-button-icon {
    visibility: visible;
  }
}

.profile-image-upload-wrapper {
  // padding:30px;
  display: flex;
  align-items: center;

  .profile-image-display {
    border: 1px solid #3a3a3a;
    border-radius: 10px;
    margin: auto;
    justify-content: center;
    display: flex;
    align-items: center;

    .canvas {
      height: 100%;
      width: 100%;
      border-radius: 5px;
    }
  }

  .upload-profile-image-button {
    padding: 8px 0px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    margin-inline-start: 10px;

    .btn-wrapper {
      // margin-bottom: 8px;
      width: 130px;
      position: relative;
      margin: auto;
      display: inline-flex;
      justify-content: center;
      margin-bottom: 10px;

      button {
        width: 96%;
      }
    }
  }
}

.profile-image-display {
  width: 100px;
  /* keep consistent with your box */
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.profile-image-display canvas {
  width: 100% !important;
  /* CSS size */
  height: 100% !important;
  /* CSS size */
  display: block;
}

.empty-field-text-styles {
  color: $dull-text-color;
  font-size: 14px;
  margin-top: 1px;
}

.btn-image {
  width: 25px;
  height: 25px;
  object-fit: cover; // ensures 1:1 ratio without distortion
  border-radius: 4px; // optional (if you want rounded edges)
}

/* For all draggable items */
.draggable-item,
.grouped-button-wrapper {
  button {
    cursor: grab !important;
    /* shows hand */
  }
}

.draggable-item:active,
.grouped-button-wrapper:active {
  button {
    cursor: grabbing !important;
    /* while dragging */
  }
}

/* Optional: if you prefer arrows instead of hand */
.draggable-item.move-cursor,
.grouped-button-wrapper.move-cursor {
  button {
    cursor: move !important;
  }
}

.task-data-value {
  max-width: 97%;
  word-break: break-all;
  text-align: start;
}

.ungrouped-placeholder {
  min-width: 120px;
  min-height: 44px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 12px;
  background: #fafafa;
  flex-basis: 100%;
  /* makes placeholder a full-width row so dropping at the end is reliable */
}

.dragging-field {
  border: 2px dotted $dull-text-color !important;
}

.learn-about-text-styles {
  display: flex;
  align-items: center;
  gap: 6px;
  color: $learn-about-text-color;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.learn-about-text-styles:hover {
  text-decoration: underline;
  color: $learn-about-text-color-hover;
}

.learn-about-overlay {
  position: fixed;
  inset-inline-start: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #00000094;
  z-index: 100000;
  display: flex;
  justify-content: flex-end;
}

.learn-about-panel {
  width: 480px;
  max-width: 90vw;
  height: 100%;
  background: $primary-background;
  border-inline-start: $secondary-border-color;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.learn-about-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: $secondary-border-color;
  background: $secondary-background-color;

  h5 {
    margin: 0;
    color: #cfcfcf;
  }
}

.learn-about-panel-body {
  padding: 16px 20px;
  overflow: auto;
  text-align: start;
  color: $text-color;
  font-size: 14px;
}

.learn-about-field-row {
  margin-bottom: 12px;
  line-height: 1.5;

  strong {
    color: #cfcfcf;
  }

  span {
    color: $secondary-text-color;
  }
}

.learn-about-subheading {
  color: $highlight-font-color;
  font-weight: 600;
  margin: 14px 0 8px;
}

.learn-about-numbered-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  color: $secondary-text-color;
}

.learn-about-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #28a745;
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
}

.learn-about-example-box {
  margin-top: 16px;
  padding: 12px;
  border: $border-color;
  border-radius: 6px;
  background: $secondary-background-color;

  code {
    color: $text-color;
    word-break: break-all;
  }
}

.learn-about-example-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: $secondary-text-color;
  font-weight: 600;
}

.learn-about-rule-card {
  margin-top: 12px;
  padding: 10px 12px;
  border: $border-color;
  border-radius: 6px;
  background: $secondary-background-color;
}

.learn-about-rule-name {
  color: $active-blue;
  font-weight: 600;
  font-size: 13px;
  word-break: break-all;
  margin-bottom: 4px;
}

.learn-about-rule-desc {
  color: $secondary-text-color;
  font-size: 13px;
  margin-bottom: 6px;
}

.learn-about-rule-example-label {
  color: $dull-text-color;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
}

.learn-about-code-block {
  margin: 8px 0 0;
  padding: 8px 10px;
  background: $primary-background;
  border: $border-color;
  border-radius: 4px;
  color: $text-color;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}

.learn-about-section-divider {
  border-top: $border-color;
  margin: 20px 0 16px;
}

.learn-about-section-title {
  color: #cfcfcf;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.learn-about-copyable-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 10px;
  background: $primary-background;
  border: $border-color;
  border-radius: 4px;

  code {
    flex: 1;
    color: $text-color;
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
    font-size: 12px;
    word-break: break-all;
    user-select: text;
    cursor: text;
  }
}

.learn-about-copy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: $dull-text-color;

  &:hover {
    color: $active-blue;
  }
}
</style>